import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { ThemeModeType } from '@application/Types/ComponentTypes'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Title = styled.h3`
    display: block;
    margin-bottom: 14px;
    margin-top: 20px;
    text-align: center;
    ${(props) => props.theme.typo.displayM}
`

export const Link = styled(LinkBase)`
    display: block;
    text-align: center;
    ${(props) => props.theme.typo.bodyM}
    text-transform: uppercase;
`

export const Arrow = styled(ArrowDirectionIcon)`
    margin-left: 8px;
    margin-right: 9px;
    vertical-align: middle;
`

export const Image = styled(ImageBase)`
    max-width: 42px;
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    display: flex;
    flex-direction: column;
    max-width: 370px;
    align-items: center;
    margin: 50px auto 0;
    ${(props) => props.theme.typo.bodyS}

    @media ${(props) => props.theme.query.min.tablet} {
        margin-top: 0;
    }

    ${Title} {
        color: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'white' : 'g600']};
    }

    ${Link} {
        color: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'white' : 'p500']};

        &:hover,
        &:focus,
        &:active {
            color: ${(props) => props.theme.color.a500};

            svg path {
                fill: ${(props) => props.theme.color.a500};
                stroke: ${(props) => props.theme.color.a500};
            }
        }
    }

    ${Arrow} path {
        stroke: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'white' : 'p500']};
    }
`
